export const SCHEDULE_STATUS_ICON_COLORS = {
	RED: 'text-danger',
	YELLOW: 'text-warning',
	GREEN: 'text-success',
	BLUE: 'text-info',
};
